import { render, staticRenderFns } from "./StudentsTrainings.vue?vue&type=template&id=2a3c7bc1&scoped=true"
import script from "./StudentsTrainings.vue?vue&type=script&lang=js"
export * from "./StudentsTrainings.vue?vue&type=script&lang=js"
import style0 from "./StudentsTrainings.vue?vue&type=style&index=0&id=2a3c7bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3c7bc1",
  null
  
)

export default component.exports